import { useForumDateFormat } from "components/ForumDateFormatProvider";
import { Space, Typography } from "components/styleguide";
import { CustomDatePickerProps } from "components/styleguide/components/DatePicker";
import DatePickerAvailableDaysWrapper from "components/styleguide/components/DatePickerAvailableDaysWrapper";
import { EventLayoutContext } from "layouts/EventLayout/types";
import moment, { Moment } from "moment";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";

const { Text } = Typography;

interface DatePickerOptionProps {
  date: Moment | undefined;
  setDate: Dispatch<SetStateAction<Moment>> | Dispatch<SetStateAction<Moment | undefined>>;
  format?: string;
}

const DatePickerOption = ({
  date,
  setDate,
  format,
  ...props
}: DatePickerOptionProps & CustomDatePickerProps) => {
  const { t } = useTranslation();
  const forumDateFormat = useForumDateFormat();

  const { forum } = useOutletContext<EventLayoutContext>();

  return (
    <Space direction={"vertical"}>
      <Text>{t("Enter Date")}</Text>
      <DatePickerAvailableDaysWrapper
        style={{ minWidth: "200px" }}
        value={date}
        onChange={(value) => setDate(value)}
        format={format ?? forumDateFormat}
        eventStartDate={moment(forum?.startDate)}
        eventEndDate={moment(forum?.endDate)}
        availableDatesGetterType={"TwelveMonthsBeforeEndOfEvent"}
        defaultPickerValue={date ? moment(date) : moment(forum?.startDate)}
        {...props}
      />
    </Space>
  );
};

export default DatePickerOption;
